import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainReportTheLossOfCard(card) {
  return maintainRequest({
    url: `/user/maintenanceMan/card/reportTheLossOfCard/${card}`,
    method: "post",
  });
}
